export const actionTypes = {
    FetchSeasonDetails: "[FetchSeasonDetails] Action",
    UpdateSeasonDetails: "[SeasonDetails] Action",
    LocationChange: "[LocationChange] Action"
};